'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _createHOC = require('wix-ui-core/dist/src/createHOC');

var _Heading = require('./Heading');

var _Heading2 = _interopRequireDefault(_Heading);

var _EllipsedTooltip = require('wix-ui-core/dist/src/hocs/EllipsedTooltip');

var _EllipsedTooltipSt = require('../common/EllipsedTooltip/EllipsedTooltip.st.css');

var _EllipsedTooltipSt2 = _interopRequireDefault(_EllipsedTooltipSt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var EllipsedHeading = (0, _EllipsedTooltip.withEllipsedTooltip)({ showTooltip: true })(_Heading2.default);

var ProxyHeading = function ProxyHeading(_ref) {
  var ellipsis = _ref.ellipsis,
      props = _objectWithoutProperties(_ref, ['ellipsis']);

  return ellipsis ? _react2.default.createElement(EllipsedHeading, _extends({}, (0, _EllipsedTooltipSt2.default)('root', {}, props), props)) : _react2.default.createElement(_Heading2.default, props);
};

ProxyHeading.propTypes = _extends({}, _Heading2.default.propTypes, {

  /** should the text get ellipsed with tooltip, or should it get broken into lines when it reaches the end of its container */
  ellipsis: _propTypes.bool
});

ProxyHeading.displayName = 'Heading';

exports.default = (0, _createHOC.createHOC)(ProxyHeading);


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/dist/src/Heading/ProxyHeading.js
// module id = 1238
// module chunks = 0